interface Network {
  linkrole?: { roleURI?: string };
}

export function filterVisibleNetworks<T extends Network>(networks: T[], hiddenURIs: Set<string>): T[] {
  if (hiddenURIs.size === 0) return networks;
  return networks.filter((n) => {
    const uri = n.linkrole?.roleURI;
    if (!uri) return true;
    return !hiddenURIs.has(uri);
  });
}
